<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>网站设置</BreadcrumbItem>
        <BreadcrumbItem>信息设置</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
      <div class="head_style">
        <h2>信息设置</h2>
      </div>
      <div>
        <p ><b>网站名称</b></p>
        <Input  placeholder="请输入网站名称" style="width: 300px" v-model="websiteinfo.webname"></Input>
      </div><br>

      <div>
        <p ><b>网站favicon</b></p>
        <div>
          <img :src="websiteinfo.icon" id="web_favicon" class="img_style">
        </div>
        <Upload action="/admin/Website/uploadWebsite" name="image" :on-success="handleSuccess" :show-upload-list="false">
            <Button icon="ios-cloud-upload-outline" id="ghost" >文件上传</Button>
        </Upload>
      </div><br>

      <div>
        <p ><b>前台logo</b></p>
        <div>
          <img :src="websiteinfo.logosjld" id="web_logosjld" class="img_style">
        </div>
        <Upload action="/admin/Website/uploadWebsite" name="image" :on-success="logosjldSuccess" :show-upload-list="false">
            <Button icon="ios-cloud-upload-outline" id="ghost" >文件上传</Button>
        </Upload>
      </div><br>
      <div>
        <p ><b>后台logo</b></p>
        <div>
          <img :src="websiteinfo.logo" id="web_logo" class="img_style">
        </div>
        <Upload action="/admin/Website/uploadWebsite" name="image" :on-success="logoSuccess" :show-upload-list="false">
            <Button icon="ios-cloud-upload-outline" id="ghost" >文件上传</Button>
        </Upload>
      </div><br><br>

      <div class="button_style">
        <Button type="success" @click="webSitePutData()">提交</Button>
      </div>
    </Content>
  </div>
</template>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
p {
  line-height: 30px;
}
.head_style {
  height: 50px;
}
.img_style{
  height:200px;
}


</style>
<script>
import website from '@/assets/js/views/bak/website';

export default {
  ...website,
};
</script>

